import React from 'react'
import AccountLayout from '../../components/AccountLayout'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import CodesPageContent from '../../components/CodesPageContent'
import Configuration from '../../Services/Api/Configuration'

const Codes = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Page.Codes.title' })}
           pathname={window.location.origin + NamedRoutes.codes}
           titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
           description={intl.formatMessage({ id: 'Page.Codes.title' })}
      />

      <AccountLayout permission={Configuration.permissions.code} content={
        <CodesPageContent/>
      }/>
    </>
  )
}

export default Codes
